/**
 * @author Carlos Fernando Herrera Guillen
 * @Copyright (c) Infotrack. All rights reserved.
 */

import notificacionGlobal from '@infotrack/presentacion-componentes/notificacionGlobal';
import ProcesarArchivo from 'Infotrack@Modelos/smartStock/procesarArchivo';

export default class ModeloCargarPlantilla {
    private modeloProcesarArchivo: ProcesarArchivo;

    constructor(){
        this.modeloProcesarArchivo = new ProcesarArchivo();
    }

    public async CargarPlantillaProducto(formData: FormData) {
       const respuesta = await this.modeloProcesarArchivo.CargarPlantillaProducto(formData);
       return respuesta;
    }

    public async CargarPlantillaInventario(formData: FormData) {
        const respuesta = await this.modeloProcesarArchivo.CargarPlantillaInventario(formData);
        return respuesta;
     }

    public validarEntidad(idBodega: number,idTipoDocumento: number,formData: File | undefined): boolean {
        if (idBodega === 0 || idTipoDocumento ===0 || formData === undefined  ) {
            notificacionGlobal('comunes.alerta.camposIncompletos', 6000, 'warning', true);
            return false;
        }
        return true;
    }

    

    
}
